import React from 'react'
import { createFeatureContainer } from '@core/feature-loading/createFeatureContainer';

export const Container = ({ children }: { children: JSX.Element }) => (
  createFeatureContainer(children)
)



// WEBPACK FOOTER //
// ./sampleProject/src/Container/index.tsx